/**
 * Created by neo on 12.04.22.
 */
import { IReactionDisposer, makeAutoObservable, onBecomeObserved, onBecomeUnobserved, reaction, runInAction } from 'mobx';
import { v4 as UUID } from 'uuid';
import { MindfulnessProgramTemplateDayUnit, createMindfulnessProgramTemplateDayUnit } from './MindfulnessProgramTemplateDayUnit';
import { PipelineContext, createPipelineContext } from '../../PipelineContext';
import { WorkoutTemplate, WorkoutTemplateApi } from '../../SuperMacro/WorkoutTemplate/WorkoutTemplate';
import { CoachWorkout, CoachWorkoutApi } from '../../Program/Workout/CoachWorkout';
import { ActivityApi } from '../../../Activity/Activity';

export type MindfulnessProgramTemplateDayUnitWorkoutTemplate = MindfulnessProgramTemplateDayUnit & {
  workoutTemplateId: string;
  context: PipelineContext;
  workoutTemplate?: WorkoutTemplate;
  generate(): Promise<CoachWorkout | undefined>;
};

export function createMindfulnessProgramTemplateDayUnitWorkoutTemplate(json?: Partial<MindfulnessProgramTemplateDayUnitWorkoutTemplate>): MindfulnessProgramTemplateDayUnitWorkoutTemplate {
  const base = createMindfulnessProgramTemplateDayUnit({ ...json, type: 'workoutTemplate' } as any);
  let workoutTemplateFetchDisposer: IReactionDisposer | undefined;

  const unit: MindfulnessProgramTemplateDayUnitWorkoutTemplate = makeAutoObservable({
    ...base,
    workoutTemplateId: json?.workoutTemplateId ?? '',
    context: createPipelineContext(json?.context as any),
    workoutTemplate: undefined as WorkoutTemplate | undefined,

    generate(): Promise<CoachWorkout | undefined> {
      return this.workoutTemplateId
        ? CoachWorkoutApi.generate(this.workoutTemplateId, this.context)
        : Promise.resolve(undefined);
    },

    toJS(newId: boolean = false) {
      return {
        ...(function() { const { id, createdAt, updatedAt, createdBy, updatedBy, name, description } = base; return { id: newId ? UUID() : id, createdAt, updatedAt, createdBy, updatedBy, name, description }; })(),
        workoutTemplateId: this.workoutTemplateId,
        context: this.context.copy(),
      };
    },
  });

  const startFetchWorkoutTemplate = () => {
    workoutTemplateFetchDisposer = reaction(
      () => unit.workoutTemplateId,
      (workoutTemplateId) => {
        if (workoutTemplateId) {
          WorkoutTemplateApi.get(workoutTemplateId).then((result) => runInAction(() => (unit.workoutTemplate = result)));
        } else {
          runInAction(() => (unit.workoutTemplate = undefined));
        }
      },
      { fireImmediately: true },
    );
  };

  const stopFetchWorkoutTemplate = () => {
    workoutTemplateFetchDisposer?.();
    workoutTemplateFetchDisposer = undefined;
  };

  onBecomeObserved(unit, 'workoutTemplate', startFetchWorkoutTemplate);
  onBecomeUnobserved(unit, 'workoutTemplate', stopFetchWorkoutTemplate);
  onBecomeObserved(unit, 'activity', () => {
    if (!unit.activity) {
      ActivityApi.get(unit.activityIdentifier).then((result) => runInAction(() => (unit.activity = result)));
    }
  });

  return unit;
}
